import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@stvgroup/stv-ui-components'
import { X as CloseIcon } from 'lucide-react'

const baseSx = {
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'common.white',
  p: 0,
  pr: '4px',
}

const CloseButton = forwardRef(({
  onClick, ariaLabel, sx, iconProps, ...props
}, ref) => (
  <Box
    ref={ref}
    component="button"
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    sx={{ ...baseSx, ...sx }}
    {...props}
  >
    <CloseIcon {...iconProps} />
  </Box>
))

CloseButton.displayName = 'CloseButton'

CloseButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  sx: PropTypes.object,
  iconProps: PropTypes.object,
}

CloseButton.defaultProps = {
  onClick: () => {},
  ariaLabel: 'Close',
  sx: {},
  iconProps: {},
}

export default CloseButton
